import { List } from 'immutable';

const downloadableEsimState = 'released';
const installedEsimState = 'installed';

export const isDownloadableEsim = (esimProfileDto) => {
    return (
        esimProfileDto && esimProfileDto.get('state') === downloadableEsimState
    );
};

export const isInstalledEsim = (esimProfileDto) => {
    return esimProfileDto && esimProfileDto.get('state') === installedEsimState;
};

export const getDownloadableOrInstalledEsim = (mobileSubscriptionDto) => {
    if (!mobileSubscriptionDto) {
        return null;
    }

    let downloadableOrInstalledEsim = mobileSubscriptionDto
        .get('pendingEsims', List())
        .find(
            (sim) =>
                sim &&
                (isDownloadableEsim(sim.get('esimProfile')) ||
                    isInstalledEsim(sim.get('esimProfile'))),
        );

    if (!downloadableOrInstalledEsim) {
        // A downloadable/installed eSIM can be found either in the 'pendingEsims' field or in the 'simcards' field,
        // depending on how it was created in the BSS.
        downloadableOrInstalledEsim = mobileSubscriptionDto
            .get('simcards', List())
            .find(
                (sim) =>
                    sim &&
                    (isDownloadableEsim(sim.get('esimProfile')) ||
                        isInstalledEsim(sim.get('esimProfile'))),
            );
    }

    return downloadableOrInstalledEsim;
};
